module.exports = __webpack_public_path__ + "static/media/otpicon.75d3274d.svg";